import {TabList} from "../../common/TabList.js";
export const handleDropdownSwitchElement = (contentElement) => {
  const menu = contentElement.querySelector(".dropdown-switch__menu");
  const tabs = new TabList(contentElement.querySelectorAll(".dropdown-switch__content"));
  menu.querySelector("select").addEventListener("change", (e) => {
    if (!(e.target instanceof HTMLSelectElement)) {
      return;
    }
    tabs.showTab(e.target.value);
  });
};
